<template>
    <div class="gallery-container">
        <div class="gallery-modal">
            <div class="gallery-main">
                <img
                        v-if="typeof currentImage.ppt_page === 'string'"
                        :src="currentImage.ppt_page"
                        class="gallery-main-image"
                />

            </div>

            <div class="text-container" v-if="currentText">
                <div>
                    <span class="text">{{currentText}}</span>
                </div>
            </div>
            <div v-else style="margin-bottom: 10px"></div>
            <div style="text-align: center;" class="btns1">
                <a-space size="large" class="btns">
                    <span style="opacity: 0">{{currentIndex+1}} / {{data.length}}</span>
                    <LeftCircleFilled class="btn-disabled" v-if="currentIndex <= 0"/>
                    <LeftCircleFilled class="btn" @click="toPrev" v-else/>
                    <span class="btn"
                          @click="togglePlay"
                    >
                        <PauseCircleFilled v-if="isPlaying" style="font-size: 24px; cursor: pointer"/>
                        <PlayCircleFilled v-else style="font-size: 24px; cursor: pointer"/>
                        </span>
                    <RightCircleFilled class="btn-disabled" v-if="currentIndex >= data.length"/>
                    <RightCircleFilled class="btn" @click="playNextImg"/>
                    <span>{{currentIndex+1}} / {{data.length}}</span>
                </a-space>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed,  defineProps, onMounted, onUnmounted, defineEmits} from 'vue';
    import {LeftCircleFilled, RightCircleFilled, PlayCircleFilled, PauseCircleFilled} from '@ant-design/icons-vue';
    // Props：接收图片数据
    const props = defineProps({
        data: Array
    });


    // 响应式数据
    const currentIndex = ref(0);

    // 计算当前图片
    const currentImage = computed(() => {
        return props.data[currentIndex.value] || {};
    });

    // 监听键盘事件

    const emit = defineEmits(['play', 'pause', 'stop', 'end']);
    const audioPlayer = ref(null);
    const currentMp3Index = ref(0);
    const isPlaying = ref(false);
    const loading = ref(false);
    const currentTime = ref(0);
    const currentText = ref('');
    const duration = ref(0);
    // SRT时间转秒
    const srtToSeconds = (srtTime) => {
        if (!srtTime) return 0

        const normalized = srtTime.replace(',', '.')
        const [timePart, msPart] = normalized.split('.')
        const [hours, minutes, seconds] = timePart.split(':').map(Number)
        const milliseconds = parseInt(msPart) || 0

        return hours * 3600 + minutes * 60 + seconds + milliseconds / 1000
    };
    // 解析时间范围
    const parseTimeRange = (timeRange) => {
        if (!timeRange.includes('-->')) {
            return null
        }

        const [startStr, endStr] = timeRange.split('-->').map(s => s.trim());
        const start = srtToSeconds(startStr);
        const end = srtToSeconds(endStr);

        return {
            start,
            end,
            startMs: start * 1000,
            endMs: end * 1000,
            duration: end - start,
            durationMs: (end - start) * 1000,
            startStr,
            endStr
        }
    };
    // 计算属性
    const audioList = computed(() => {
        return currentImage.value?.ppt_audio_and_info || []
    });
    const currentAudio = computed(() => {
        return audioList.value[currentMp3Index.value] || null
    });

    // 初始化播放器
    const initPlayer = () => {
        audioPlayer.value = new Audio();

        // 添加事件监听
        audioPlayer.value.addEventListener('loadedmetadata', () => {
            duration.value = audioPlayer.value.duration
        });

        audioPlayer.value.addEventListener('timeupdate', () => {
            currentTime.value = audioPlayer.value?.currentTime;
            console.log(audioPlayer.value?.currentTime);
            let {axis_info} = currentAudio.value || {};
            if(Array.isArray(axis_info)){
                let axis = axis_info.find(a=>{
                    let {start, end} = parseTimeRange(a.time);
                    return currentTime.value >= start && currentTime.value <= end;
                });
                if(axis?.text){
                    if(currentText.value !== axis.text) {
                        currentText.value = axis.text;
                        console.log(axis?.text)
                    }
                }
            }

        });

        audioPlayer.value.addEventListener('ended', () => {
            playNext()
        });

        audioPlayer.value.addEventListener('error', (error) => {
            console.error('播放错误:', error);
            loading.value = false
        })
    };

    // 切换播放状态
    const togglePlay = async () => {
        if (!currentAudio.value) return;
        if (isPlaying.value) {
            pause()
        } else {
            await play()
        }
    };

    // 播放
    const play = async () => {
        if (!audioPlayer.value) {
            initPlayer();
            console.log('初始化播放器')
        }
        console.log(currentMp3Index.value);
        console.log(currentMp3Index.value);
        console.log(currentAudio.value);
        if(!currentAudio.value){
            return ;
        }
        if (audioPlayer.value.src !== currentAudio.value.audio) {
            loading.value = true
            audioPlayer.value.src = currentAudio.value.audio
            await audioPlayer.value.load()
        }

        try {
            await audioPlayer.value.play()
            isPlaying.value = true;
            console.log('play...');
            emit('play', currentMp3Index.value)
        } catch (error) {
            console.error('播放失败:', error)
        } finally {
            loading.value = false
        }
    };
    const toPrev = ()=>{
        if (currentIndex.value <= 0) {
            return;
        }
        currentIndex.value --;
        currentMp3Index.value = 0;
        stop();
        play();
    };
    const playNextImg = ()=>{
        stop();
        if (currentIndex.value >= props.data.length - 1) {
            return;
        }
        currentIndex.value ++;
        currentMp3Index.value = 0;
        play();
    };
    // // 暂停
    const pause = () => {
        if (audioPlayer.value) {
            audioPlayer.value.pause();
            isPlaying.value = false;
            emit('pause', currentMp3Index.value)
        }
    };

    // 停止
    const stop = () => {
        if (audioPlayer.value) {
            audioPlayer.value.pause()
            audioPlayer.value.currentTime = 0
            isPlaying.value = false
            currentTime.value = 0
            emit('stop', currentMp3Index.value)
        }
    };

    // 播放下一首
    const playNext = () => {
        if (currentMp3Index.value < audioList.value.length - 1) {
            console.log(currentMp3Index.value, '播放完了');
            currentMp3Index.value++;
            stop();
            play()
        }else{
            console.log('最后一段播放完了');
            currentMp3Index.value = 0;
            playNextImg();
        }
    };

    // // 播放上一首
    // const playPrevious = () => {
    //     if (currentMp3Index.value > 0) {
    //         currentMp3Index.value--
    //         stop()
    //         play()
    //     }
    // }

    // // 切换音频
    // const changeAudio = (index) => {
    //     currentMp3Index.value = index
    //     stop()
    //     play()
    // }


    onMounted(()=>{
        console.log('课件')
    });
    // 清理资源
    onUnmounted(() => {
        if (audioPlayer.value) {
            audioPlayer.value.pause();
            audioPlayer.value = null
        }
    })
</script>

<style scoped>
    .text-container{
        text-align: center; padding: 5px;
        height: 60px;
        display: flex;
        flex-direction: column;
        justify-content: flex-end; /* 这一行使内容在容器底部 */
    }
    .text{
        background: #A9ABAE;
        border-radius: 4px;
        color: #FFF;
        padding: 2px 4px
    }
    .btns{
        background: #F2F2F2;
        border-radius: 20px;
        padding: 6px 10px;
    }
    .btn, .btn-disabled{
        cursor: pointer;
        font-size: 25px;
        color: rgba(0,0,0, 0.8);
    }
    .btn-disabled{
        color: rgba(0,0,0,0.1);
    }
    .btn:hover{
        color: rgba(0,0,0,1);
    }
    .gallery-container {
        /*padding: 20px;*/
    }

    /*.text{*/
    /*    margin-top: -80px*/
    /*}*/

    /* 画廊模态框 */
    .gallery-modal {
        padding: 2px;
    }

    .gallery-main {
        position: relative;
        /*margin-bottom: 10px;*/
        /*height: 400px;*/
        background-size: cover;
        /*background;*/
    }

    .gallery-main-image {
        width: 100%;
        max-height: 600px;
        object-fit: contain;
        border-radius: 8px;
    }


    .gallery-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }


    /* 全屏模态框样式 */
    :deep(.fullscreen-modal .ant-modal-content) {
        background: rgba(0, 0, 0, 0.9);
        border: none;
    }

    :deep(.fullscreen-modal .ant-modal-body) {
        padding: 0;
    }
    @media (max-width: 480px) {
        /*.gallery-main-image{*/
        /*    width: 84%*/
        /*}*/
        /*.text{*/
        /*    margin-top: -50px*/
        /*}*/
    }
</style>